/*星級評價 start*/
$(function(){
	var timer;
    timer=setInterval(function(){ 
    	searchStar()
    }, 1000);
  function searchStar(){
    var length=$(".shopify_spr").length;
    var num=0;
    $(".shopify_spr").each(function(){
    	var starEl=$(this).find(".spr-badge");
        if(starEl.html()){
          	num++;
        }
    })
    if(length==num){
    	changeStar();
        clearInterval(timer)
    }
  }
  function changeStar(){
     $(".shopify_spr").each(function(){
        var el=$(this).find(".spr-badge");
         if(el.html()){
           var grade=el.attr("data-rating");
            if(grade){
              var gradeStr=grade+'';
              gradeStr=grade.substring(0,3)
              
              // el.find(".spr-badge-caption").html(gradeStr+" grade");
              
              if(grade==5){
                
               }else if(grade<5 && grade>=4){
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(4);
                  elS.append("<span style='width:50%'></span>");

               }else if(grade<4 && grade>=3){
                  el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(3);
                  elS.append("<span style='width:50%'></span>");
               }else if(grade<3 && grade>=2){
                  el.find(".spr-badge-starrating .spr-icon").eq(3).hide();
                  el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(2);
                  elS.append("<span style='width:50%'></span>");
               }else if(grade<2 && grade>=1){
                  el.find(".spr-badge-starrating .spr-icon").eq(2).hide();
                  el.find(".spr-badge-starrating .spr-icon").eq(3).hide();
                  el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(1);
                  elS.append("<span style='width:50%'></span>");
               }else{
                  el.find(".spr-badge-starrating .spr-icon").hide();
                  var elS=el.find(".spr-badge-starrating .spr-icon").eq(0);
                  elS.show();
                  elS.append("<span style='width:50%'></span>");
               }
             }
     	}  
  	
     })
     $(".shopify_spr .spr-badge").show();
  }
})
/*星級評價 end*/

//折扣系列判断当前可使用的start
$(function(){
  $(".grid-item").each(function(){
    $(this).find(".yh").each(function(){
    	var  isshow=1
        var etime=$(this).attr("etime");
        etime=etime.replace(/-/g,"/");
        var stime=$(this).attr("stime");
        stime=stime.replace(/-/g,"/");
        var dN=new Date()
        var timestampN=dN.getTime();
        if(stime){
            var dS=new Date(stime+" EDT")
            var timestampS=dS.getTime();
            if(timestampS>timestampN){
                   isshow=0;
           }
        }
        if(etime){
            var dE=new Date(etime+" EDT")
            var timestampE=dE.getTime();
            if(timestampN>timestampE){
                $(this).remove();
                isshow=0;
            }
        }
        if(isshow){
          $(this).show();
          return false;
        }
    })
    
  })
})
//折扣系列判断当前可使用的end